import { useState } from 'react'

// Web has no toast system (the shopper components use inline <p className="error">).
// This standardises that for the management forms: a small banner + a hook that
// extracts the `userErrors[0].message` shape every mutation returns.

export interface UserError {
  field?: string[] | null
  message: string
}

export function Feedback({ error, success }: { error?: string | null; success?: string | null }) {
  if (!error && !success) return null
  return error
    ? <p className="error" role="alert">{error}</p>
    : <p className="feedback-success" role="status">{success}</p>
}

export function useFormFeedback() {
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  /** Returns true when there were no userErrors (caller can proceed). */
  function fromUserErrors(errs: UserError[] | null | undefined): boolean {
    const msg = errs?.[0]?.message
    if (msg) { setError(msg); setSuccess(null); return false }
    return true
  }

  function reset() { setError(null); setSuccess(null) }

  return { error, success, setError, setSuccess, fromUserErrors, reset }
}
